import React from 'react';

import { QueryClientProvider } from '@tanstack/react-query';
import queryClient from 'react-query-settings/queryClient';

import AppWrapper from 'components/apps/AppWrapper';
import NavigationOptionSearch from 'components/projectsDashboard/components/NavigationOptionSearch';

export default function NavigationOptionSearchWrapper({ contextProps }) {
  return (
    <AppWrapper {...contextProps}>
      <QueryClientProvider client={queryClient}>
        <NavigationOptionSearch />
      </QueryClientProvider>
    </AppWrapper>
  );
}
